import dayjs from 'dayjs'
import tz from 'dayjs/plugin/timezone'
dayjs.extend(tz)

import ajaxRequest from 'utils/_ajax-request.js'

let getTranslatedThemeTitle = () => {
  if ('en' === document.documentElement.lang) {
    return 'Theme'
  } else if ('de' === document.documentElement.lang) {
    return 'Theme'
  } else if ('fr' === document.documentElement.lang) {
    return 'Theme'
  } else if ('ru' === document.documentElement.lang) {
    return 'Тема'
  }
}

let renderMessage = (bemBlock, adminChat, author, themeTitle) =>
  (orderChatMessage) => {

    let date = dayjs(new Date(orderChatMessage.createdAt * 1000)).tz("Europe/Vienna")
    let messageText = orderChatMessage.text.replace(/\n/g, '<br>')
    return `
<div class="${ bemBlock.name }-item${ author ? ' ' + bemBlock.name + '-item--user' : ''}">
    <div class="${ bemBlock.name }-author">${ orderChatMessage.author.personalName }</div>
` + (!adminChat ? `    <div class="${ bemBlock.name }__chat-theme">${ themeTitle }: ${ orderChatMessage.theme }</div>` : ``) + `
    <div class="${ bemBlock.name }-message${ author ? ' --my-message' : '' }">
        <div>${ messageText }</div>
        <div class="${ bemBlock.name }-date">${ date.format('YYYY-MM-DD HH:mm:ss') }</div>
    </div>
</div>
`
  }

/**
 * @param {HTMLInputElement} themeElement
 * @param {HTMLTextAreaElement} textElement
 * @param {HTMLElement} historyElement
 * @param {function} messageRenderer
 */
let addMessage = (
  themeElement,
  textElement,
  historyElement,
  messageRenderer,
) => (xhr, error) => {
  if( error ) {
    return false
  }
  themeElement && (themeElement.value = '')
  textElement.value = ''
  themeElement && themeElement.dispatchEvent(new Event('input', { bubbles: true }))
  textElement.dispatchEvent(new Event('input', { bubbles: true }))
  historyElement.prepend((new DOMParser).parseFromString(messageRenderer(JSON.parse(xhr.responseText)), document.contentType).body.childNodes[0])
}

export default (
  orderId,
  adminChat,
  url,
) => {
  let themeElement = adminChat ? null : document.getElementById('order_' + (adminChat ? 'admin_' : '') + 'chat_theme')
  let textElement = document.getElementById('order_' + (adminChat ? 'admin_' : '') + 'chat_text')
  let sendElement = document.getElementById('order_' + (adminChat ? 'admin_' : '') + 'chat_send')
  let historyElement = document.getElementById('order_' + (adminChat ? 'admin_' : '') + 'chat_history')

  if (!((adminChat || themeElement) && textElement && sendElement && historyElement)) {
    return
  }

  sendElement.addEventListener('click', function(e) {

    if( (adminChat && themeElement && themeElement.value.trim() == '') || (textElement && textElement.value.trim() == '') ) {
      //console.log('empty')
      return
    }

    if( themeElement && themeElement.value == '' ) {
      return
    }

    let formData = new FormData()
    formData.append('order_id', orderId)
    adminChat || formData.append('theme', themeElement.value)
    formData.append('text', textElement.value)

    ajaxRequest(
      addMessage(themeElement, textElement, historyElement, renderMessage(
        {name: 'order-detail-cards__chat'},
        adminChat,
        true,
        getTranslatedThemeTitle(),
      )),
      url,
      formData,
      'POST',
    )
  })
}
